/**
 * Lê o `role` do token de shell.
 *
 * O host assina o token com a claim `role` (ver `issueAppShellToken`), mas o
 * `decodeAppShellToken` do SDK não a expõe no `AppContext` — devolve só
 * tenant/user/installation/app/permissions/locale/path/exp. Por isso lemos o
 * payload em cru aqui.
 *
 * Isto é **só para UX**: decidir que separadores mostrar. O gate a sério é o
 * `min_role` por action, aplicado no host, que devolve 403 a quem não pode.
 */

export function readRoleFromToken(token: string): number | null {
  try {
    const [, payloadPart] = token.split(".")
    if (!payloadPart) return null
    const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/")
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=")
    const binary = atob(padded)
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
    const payload = JSON.parse(new TextDecoder().decode(bytes))
    const role = Number(payload?.role)
    return Number.isFinite(role) ? role : null
  } catch {
    return null
  }
}
